module.exports = __webpack_public_path__ + "img/news-1.225324f0.jpg";